/**
 * iter_226 · Phase 22 — "Sell This Track" CTA on the Dashboard.
 *
 * Renders only when either (a) the backend Singles Store kill switch
 * `singles.enabled = true`, or (b) the viewer is an admin / founder
 * (so we can verify authoring + moderation flows without exposing
 * purchasing to regular artists). Owner-gate is enforced by the
 * parent (`user.user_id === submission.user_id`) AND on the backend
 * endpoint (`POST /api/singles/list-from-track/{submission_id}`).
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const SellThisTrackButton = ({ submissionId }) => {
  const nav = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/singles/access/status")
      .then((r) => { if (alive) setVisible(!!(r.data?.can_sell)); })
      .catch(() => { if (alive) setVisible(false); });
    return () => { alive = false; };
  }, []);

  if (!visible) return null;
  return (
    <Button
      size="sm"
      variant="outline"
      className="text-xs border-emerald-500/50 text-emerald-300 hover:bg-emerald-500/10"
      onClick={() => nav(`/singles/sell/${submissionId}`)}
      data-testid={`sell-track-btn-${submissionId}`}
      title="List this track in the RGM Singles Store"
    >
      💿 Sell This Track
    </Button>
  );
};

export default SellThisTrackButton;
